import * as React from 'react';
import classnames from 'classnames';

const HighlightedContent = ({ children , className  })=>{
    if (!children) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('highlighted-content', className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "highlighted-content__inner"
    }, /*#__PURE__*/ React.createElement("article", {
        className: "highlighted-content__items"
    }, children)));
};
var HighlightedContent$1 = HighlightedContent;

export { HighlightedContent$1 as default };
//# sourceMappingURL=HighlightedContent.js.map
